
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class LogEntryMailModel extends Model<LogEntryMailModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'sendDateTime', type: 'Date', languageString: 'logEntryMail.property.sendDateTime' },
		{ name: 'recipients', type: 'string[]', languageString: 'logEntryMail.property.recipients', isArray: true },
		{ name: 'subject', type: 'string', languageString: 'logEntryMail.property.subject' },
		{ name: 'sender', type: 'string', languageString: 'logEntryMail.property.sender' },
		{ name: 'attachments', type: 'LogEntryMailAttachmentModel[]', languageString: 'logEntryMail.property.attachments', isHidden: true, isArray: true, isObject: true, new: () => { return new LogEntryMailAttachmentModel }, properties: () => { return LogEntryMailAttachmentModel.classProperties } }
	];
	[key: string]: any;
	
	public sendDateTime?: Date;
	public recipients: string[];
	public subject: string;
	public sender: string;
	public attachments: LogEntryMailAttachmentModel[];
    
	constructor(){
		super();
		this.sendDateTime = undefined;
		this.recipients = [];
		this.subject = '';
		this.sender = '';
		this.attachments = [];
		
	}
	getProperties(){
		return LogEntryMailModel.classProperties;
	}
}
export class LogEntryMailAttachmentModel extends Model<LogEntryMailAttachmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'filePath', type: 'string', languageString: 'logEntryMailAttachment.property.filePath' },
		{ name: 'containerName', type: 'string', languageString: 'logEntryMailAttachment.property.containerName' },
		{ name: 'attachmentName', type: 'string', languageString: 'logEntryMailAttachment.property.attachmentName' }
	];
	[key: string]: any;
	
	public filePath: string;
	public containerName: string;
	public attachmentName: string;
    
	constructor(){
		super();
		this.filePath = '';
		this.containerName = '';
		this.attachmentName = '';
		
	}
	getProperties(){
		return LogEntryMailAttachmentModel.classProperties;
	}
}

